import { Injectable } from '@angular/core';

import { Api } from '../api/api';

@Injectable()
export class Workflow {

  constructor(public api: Api) { }

  get(params?: any) {
    return this.api.get('index.php/mobile/workflow/get', params);
  }

  get_task(params?: any) {
    return this.api.get('index.php/mobile/workflow/get_task', params);
  }

  get_description(params?: any) {
    return this.api.post('index.php/Workflow_transaction_log/get_description', params);
  }

  get_state(params?: any) {
    return this.api.post('index.php/workflow_transaction/get_state', params);
  }

  change_state(params?: any) {
    return this.api.post('index.php/workflow_transaction/save_auto_start', params);
  }

  get_parameter_data(params?: any) {
    return this.api.post('index.php/workflow_transaction_log_mobile/get_source_form_mobile', params);
  }

  get_monitoring(params?: any) {
    return this.api.get('index.php/mobile/workflow/get_monitoring', params);
  }

  get_task_monitoring(params?: any) {
    return this.api.get('index.php/mobile/workflow/get_task_monitoring', params);
  }

  get_chronology(params?: any) {
    return this.api.get('index.php/mobile/workflow/get_chronology', params);
  }
}



// WEBPACK FOOTER //
// ./src/providers/aproval_erp/workflow/workflow.ts